module.exports = __webpack_public_path__ + "img/logo-elly-energie.79801ad6.png";